// ---------------------------------------------------------------------------
// EvaluationRun — one execution of an EvaluationTemplate. Workspace-scoped,
// server-assigned id. Mirrors WorkflowSvc.Api.Contracts.EvaluationRunResponse.
//
// Note on naming: the request body field is `runOrigin` while the response
// field is `runKind` (same enum). That asymmetry comes from the C# DTO and
// is preserved on the wire.
// ---------------------------------------------------------------------------

import type { SystemProperties } from './common.js';

export type RunOrigin = 'hosted' | 'external';

export type RunState =
  | 'pending'
  | 'running'
  | 'cancelling'
  | 'cancelled'
  | 'completed'
  | 'failed';

export interface EvaluationRun {
  workspaceName: string;
  id: string;
  displayName?: string;
  /** Server response uses `runKind` (not `runOrigin` like the request). */
  runKind: RunOrigin;
  runState: RunState;
  errorMessage?: string;
  systemProperties: SystemProperties;
}

export interface QueueEvaluationRunBody {
  /** Defaults to "hosted" server-side when omitted. */
  runOrigin?: RunOrigin;
  templateName: string;
  displayName?: string;
  variables?: Record<string, unknown>;
}

export function isActiveState(state: RunState): boolean {
  return state === 'pending' || state === 'running' || state === 'cancelling';
}

export function isCancellableState(state: RunState): boolean {
  return state === 'pending' || state === 'running';
}
